import { memo } from 'react';
import { Trans } from 'react-i18next';
import FeedbackMessageWrapper from './FieldFeedback.style';
import { MessageProps } from '../Form.types';

export type FieldFeedbackProps = {
  noFeedback?: boolean;
  feedbackOnlyIfMessage?: boolean;
  messageProps: MessageProps;
};

const FieldFeedback = (props: FieldFeedbackProps) => {
  const { noFeedback, feedbackOnlyIfMessage, messageProps } = props;

  if (noFeedback) return null;

  if (feedbackOnlyIfMessage && !messageProps?.i18nKey) return null;

  return (
    <FeedbackMessageWrapper>
      {messageProps?.i18nKey && <Trans {...messageProps} />}
    </FeedbackMessageWrapper>
  );
};

export default memo(FieldFeedback) as typeof FieldFeedback;
